import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';
import { SICOM_PATHS } from 'src/sicom-paths';
import { ReportCertidaoJubilamentoMedicoRequest, ReportCertidaoJubilamentoMedicoResponse, ReportJobCreatedResponse, ReportJobStatusResponse } from './certidao-jubilamento-medico.model';

@Injectable({ providedIn: 'root' })
export class CertidaoJubilamentoMedicoService extends BaseService {
    readonly PATH = SICOM_PATHS.registro.medico.reports.certidaoJubilamentoMedico;

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    exportarPdf(request: ReportCertidaoJubilamentoMedicoRequest): Observable<HttpResponse<ReportCertidaoJubilamentoMedicoResponse | ReportJobCreatedResponse>> {
        return this.http.post<ReportCertidaoJubilamentoMedicoResponse | ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf`, request, { observe: 'response' });
    }

    iniciarGeracaoAssincrona(request: ReportCertidaoJubilamentoMedicoRequest): Observable<ReportJobCreatedResponse> {
        return this.http.post<ReportJobCreatedResponse>(`${this.PATH}/exportar-pdf-async`, request);
    }

    consultarStatus(jobId: string): Observable<ReportJobStatusResponse> {
        return this.http.get<ReportJobStatusResponse>(`${this.PATH}/job/${jobId}/status`);
    }

    baixarPdf(jobId: string): Observable<ArrayBuffer> {
        return this.http.get(`${this.PATH}/job/${jobId}/download`, { responseType: 'arraybuffer' });
    }
}
